

// mutation types
export const SET_ALERT = "setAlert";

const state = {
    variantAlert: '',
    textAlert: '',
    type: '',
    run: 0
};

const getters = {

    gettersTextAlert(state) {
        return state.textAlert;
    },

    gettersVariantAlert(state) {
        return state.variantAlert;
    },

    gettersTypeAlert(state) {
        return state.type;
    },

    gettersRunAlert(state){
        return state.run
    }
};

const actions = {

};

const mutations = {

    [SET_ALERT](state, data) {
        state.textAlert = data.text;
        state.variantAlert = data.variant;
        state.type = data.type;
        state.run++;

    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
